import Raven from 'raven-js';
const LIBRARY_NAME = 'ui-universal-auth';
export function captureException(error, options = {}) {
  Raven.captureException(error, Object.assign({}, options, {
    tags: Object.assign({}, options.tags, {
      library_name: LIBRARY_NAME
    })
  }));
}
export function captureMessage(message, options = {}) {
  Raven.captureMessage(message, Object.assign({}, options, {
    tags: Object.assign({}, options.tags, {
      library_name: LIBRARY_NAME
    })
  }));
}

// Raven only keeps `cause` when it is a real Error, so normalize the unknown
// values that reach our catch blocks before wrapping them.
export function toError(value) {
  return value instanceof Error ? value : new Error(String(value));
}